import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { BillBreakdownLine } from "./billBreakdown"
import { IBillBreakdownLine } from "./billBreakdown.types"
import { BillBreakdownLine as BillBreakdownLineDto } from "@/api/backofficeRest/generated/model"

export type IBillBreakdownLineRaw = BillBreakdownLineDto

export const BillBreakdownLineParser: IParser<
  IBillBreakdownLine,
  IBillBreakdownLineRaw
> = {
  toDomain: (data: IBillBreakdownLineRaw): IBillBreakdownLine => {
    try {
      return new BillBreakdownLine(
        Number(data.id),
        data.description,
        data.billCurrencyAmount,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
